/**
 * Utility functions for handling image URLs
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://e.haazri.net/api';

/**
 * Converts a relative image path from the database to a full URL
 * @param {string} imagePath - Relative path from database (e.g., "api\images\carousel\image.png")
 * @returns {string} - Full URL to the image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';

  // If it's already a full URL, return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Remove 'api' prefix if it exists and normalize slashes
  let cleanPath = imagePath.replace(/\\/g, '/'); // Convert backslashes to forward slashes

  // Remove leading 'api/' if present
  if (cleanPath.startsWith('api/')) {
    cleanPath = cleanPath.substring(4);
  }

  // Ensure the path starts with a slash
  if (!cleanPath.startsWith('/')) {
    cleanPath = '/' + cleanPath;
  }

  // Construct full URL
  return `${API_BASE_URL}${cleanPath}`;
};

/**
 * Gets the full URL for an image, with fallback support
 * @param {string} imagePath - Relative path from database
 * @param {string} fallback - Optional fallback URL if image path is empty
 * @returns {string} - Full URL to the image or fallback
 */
export const getImageUrlWithFallback = (imagePath, fallback = '') => {
  if (!imagePath) return fallback;
  return getImageUrl(imagePath);
};

export default {
  getImageUrl,
  getImageUrlWithFallback,
};
